import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import '@/assets/toolsModal.scss';
import toolsPurchase from '@/views/account/constants/toolsPurchase';
import { ReactComponent as SelectItem } from '@/views/account/assets/icons/select-item.svg';
import { requestPurchaseUrl } from '@/views/account/api/apiHistory';
import Utils from '../../utils/utils';
import action from '../../views/account/redux/action';
import {
  requsetGetPurchase,
  requsetGetSubscription,
  requsetGetAllSubscription,
} from '@/views/account/api/apis';
import sentGAEvent from '../../views/account/ga';
import { useTranslation } from 'react-i18next';
import myUtil from '../../utils/index';
import cartUrl from '@/views/account/utils/cartUrl';
const ToolsPurchaseModal = () => {
  const [plan, setPlan] = useState(0); //1:week,2:month,3:yearly
  const [leaveModal, setLeaveModal] = useState(true);
  const changeSelect = (value) => {
    setPlan(value);
  };
  const { t } = useTranslation(['toolsPurchaseVideoEnhancer']);
  const planArr = ['week', 'month', 'year'];
  const planLabelArr = ['Weekly', 'Monthly', 'Yearly'];

  const [urlParam, setUrlParam] = useState('');
  const dispatch = useDispatch();
  const reducerData = useSelector((state) => state.account.toolsModal);

  const { open, fromSource } = reducerData;
  // const isVip =
  //   subscriptionData.filter((item) => {
  //     return item.product_name === toolsPurchase[`${fromSource}`]?.productName;
  //   }).length > 0;

  // console.log(isVip, subscriptionData);
  const actionArr = {
    videoEnhancer: '04VE_BuyClick',
    photoEnhancer: '05PE_BuyClick',
    videoRemoveWaterMark: '01VWR_BuyClick',
    backgroundRemover: '08BR_BuyClick',
    removeTTWaterMark: '03TWR_BuyClick',
    dynamicPhoto: '22AO_BuyClick',
  };
  useEffect(() => {
    if (window.location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      const urlParam = myUtil.getUrlParam(location.href);
      setUrlParam(urlParam);
    } else {
      const track = cartUrl('');
      let obj = {};
      Object.keys(track).map((v) => {
        const objName = `track[${v}]`;
        obj[objName] = `${track[v]}`;
      });
      setUrlParam(obj);
    }
  }, []);

  const getPurchaseUrl = () => {
    if (fromSource === 'videoRemoveWaterMark') {
      setLeaveModal(false);
    }
    console.log(plan, urlParam, toolsPurchase[`${fromSource}`]);
    let newParam = { ...urlParam };
    newParam['track[reason]'] = '17';
    newParam['track[func]'] = toolsPurchase[`${fromSource}`].func;
    console.log(newParam);
    let planData = planArr[plan];
    let planLabel = planLabelArr[plan];
    sentGAEvent({
      category: 'BuyClick',
      action: actionArr[fromSource],
      label: `V2Tools_${planLabel}_${Utils.systemCheck()}`,
    });

    let cycle = '';
    if (planData === 'month') {
      cycle = `2`;
    } else if (planData === 'year') {
      cycle = `3`;
    } else {
      cycle = `1`;
    }
    let str = `plan=${planData}&site=${Utils.getLanguage()}`;
    if (toolsPurchase[`${fromSource}`].fromProduct) {
      str = str + `&FromProduct=${toolsPurchase[`${fromSource}`]?.fromProduct}`;
    }
    requestPurchaseUrl(toolsPurchase[`${fromSource}`].path + '?' + str).then(
      (res) => {
        if (res.code === 200) {
          let url =
            res.data.cart_url +
            `&track[type]=${newParam['track[type]']}&track[sid]=${newParam['track[sid]']}&track[func]=${newParam['track[func]']}&track[reason]=${newParam['track[reason]']}&track[host]=${newParam['track[host]']}&track[platform]=${newParam['track[platform]']}&track[cycle]=${cycle}&track[ab]=${newParam['track[ab]']}&track[channel]=${newParam['track[channel]']}&track[discount]=${newParam['track[discount]']}`;
          window.open(url);
        }
      }
    );
  };
  const getSource = (param) => {
    if (param === 0) {
      return { i18Key: 'ProcessingLimit', num: '600MB' };
    } else if (param === 1) {
      return { i18Key: 'ProcessingLimit', num: '3000MB' };
    } else if (param === 2) {
      return { i18Key: 'ProcessingLimit', num: '40000MB' };
    }
  };
  const closeModal = () => {
    const currentSource = fromSource;
    dispatch(
      action.onOpenToolsPurchase({
        open: false,
        fromSource: '',
      })
    );
    if (currentSource === 'videoRemoveWaterMark' && leaveModal) {
      dispatch(
        action.onOpenLeaveDialog({
          open: true,
        })
      );
    }
    setLeaveModal(true);
    requsetGetSubscription()
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          console.log('res---------------', res);
          dispatch(action.onSubscriptionChange(res.data.subscription));
        }
      })
      .catch((err) => {
        console.log(err);
      });
    requsetGetAllSubscription().then((res) => {
      console.log(res);
      if (res.code === 200) {
        console.log('allRes..............', res);
        dispatch(action.getAllSubscription(res.data.subscription));
      }
    });
  };
  return (
    <Modal
      centered
      width={1000}
      className='toolsPurchase'
      visible={open}
      footer={null}
      maskClosable={false}
      onCancel={() => closeModal()}
    >
      <div className='toolsLeft'>
        <div className='toolsTitle'>
          {toolsPurchase[`${fromSource}`]?.title}
          <span className='pro'>pro</span>
        </div>
        <div className='toolsContent'>
          {toolsPurchase[`${fromSource}`]?.text.map((item, value) => {
            return (
              <div className='contentList'>
                <SelectItem className='selectIcon' />
                <div
                  style={{
                    fontWeight:
                      fromSource === 'videoEnhancer' && value === 0 ? 700 : 400,
                  }}
                >
                  {fromSource === 'videoEnhancer' && value === 0
                    ? t(getSource(plan).i18Key, { num: getSource(plan).num })
                    : item.content}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className='toolsRight'>
        {toolsPurchase[`${fromSource}`]?.price.map((item, value) => {
          return (
            <div
              key={'Select' + value}
              onClick={() => changeSelect(value)}
              className={`priceCard ${plan === value ? 'selected' : ''}`}
            >
              <span className='date'>{item.subTitle}</span>
              <div className='price'>
                {item.price}
                <span className='everyWeek'>
                  /{toolsPurchase[`${fromSource}`]?.unit}
                </span>
              </div>
              <div className='totalPrice'>
                {plan === value && item.totalPrice ? (
                  <span>
                    {item.totalPrice}/{item.subTitle}
                  </span>
                ) : (
                  ''
                )}
              </div>
            </div>
          );
        })}
        {/**周 */}

        {/**月 */}

        <Button onClick={() => getPurchaseUrl()} className='buyNow'>
          {t('purchase:buyBtn')}
        </Button>
      </div>
    </Modal>
  );
};

export default ToolsPurchaseModal;
